import React, { type FunctionComponent } from 'react'
import { Breadcrumb } from '@retailer-platform/shared-components'
import { AccountManagementBreadcrumbs } from 'domains/account-management/components/breadcrumbs/AccountManagementBreadcrumbs'
import { useDomainMessage } from 'domains/account-management/utils/domain/intl'

export const CreateAccountBreadcrumbs: FunctionComponent = () => {
  const message = useDomainMessage('accountManagementDomain.breadcrumbs.create')

  return (
    <AccountManagementBreadcrumbs>
      <Breadcrumb>{message}</Breadcrumb>
    </AccountManagementBreadcrumbs>
  )
}
